import { COLOR } from 'vars/index'

export const BannerOverlay = {
  None: COLOR.TRANSPARENT,
  BANNER_HORIZONTAL_OVERLAY: COLOR.BANNER_HORIZONTAL_OVERLAY,
  BANNER_VERTICAL_OVERLAY: COLOR.BANNER_VERTICAL_OVERLAY,
  SURFACE_OPACITY_DARK_40: COLOR.SURFACE_OPACITY_DARK_40,
  BANNER_PARTIAL_HORIZONTAL_OVERLAY: COLOR.BANNER_PARTIAL_HORIZONTAL_OVERLAY,
} as const
export type BannerOverlay = (typeof BannerOverlay)[keyof typeof BannerOverlay]

export const BannerOverlayDirection = {
  OVERLAY_HORIZONTAL: 'OVERLAY_HORIZONTAL',
  OVERLAY_VERTICAL: 'OVERLAY_VERTICAL',
  OVERLAY_FULL: 'OVERLAY_FULL',
  OVERLAY_HORIZONTAL_VERTICAL: 'OVERLAY_HORIZONTAL_VERTICAL',
  OVERLAY_HORIZONTAL_FULL: 'OVERLAY_HORIZONTAL_FULL',
  OVERLAY_VERTICAL_FULL: 'OVERLAY_VERTICAL_FULL',
  OVERLAY_HORIZONTAL_VERTICAL_FULL: 'OVERLAY_HORIZONTAL_VERTICAL_FULL',
} as const
export type BannerOverlayDirection =
  (typeof BannerOverlayDirection)[keyof typeof BannerOverlayDirection]

export const BannerJustifyContent = {
  Flex_start: 'flex-start',
  Center: 'center',
  Flex_end: 'flex-end',
  Space_between: 'space-between',
  Space_around: 'space-around',
  Space_evenly: 'space-evenly',
} as const
export type BannerJustifyContent =
  (typeof BannerJustifyContent)[keyof typeof BannerJustifyContent]

export const BannerAlignItems = {
  Start: 'start',
  Center: 'center',
  End: 'end',
} as const
export type BannerAlignItems =
  (typeof BannerAlignItems)[keyof typeof BannerAlignItems]

export const BannerCursor = {
  Pointer: 'pointer',
} as const
export type BannerCursor = (typeof BannerCursor)[keyof typeof BannerCursor]
